// extracted by mini-css-extract-plugin
export default {"tooltip-container":"Ttip_tooltip-container__gsTVE","tooltip-content":"Ttip_tooltip-content__igNfK"};